import React, { useState } from 'react';
import Header from '../Header/Header';
import SearchModal from '../SearchModal/SearchModal';
import './Layout.css';
import Footer from '../Footer/Footer';

const Layout = ({ children }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <div className="layout">
      <Header onSearchClick={() => setIsSearchOpen(true)} />
      <main className="layout__main">
        {children}
      </main>
      <SearchModal 
        isOpen={isSearchOpen} 
        onClose={() => setIsSearchOpen(false)} 
      />
      <Footer />
    </div>
  );
};

export default Layout;